// 同期まわりの設定（端末ローカル＝kv['syncPrefs']）。Drive 完全双方向の土台。
//  - autoUpload: 取り込んだメディアを Drive へ上げる回線（'wifi'=Wi-Fi時のみ / 'always'=モバイルも）
//  - download:   Drive からメディアを取得する方法（'wifi'=Wi-Fi時に全ダウンロード / 'stream'=ストリーミングも可＝モバイルでも視聴）
// ※ 既定は Wi-Fi 全DL（ループ/スクラブ多用の語学用途に最適）。ストリーミングは通信/容量を節約したい人向けの選択肢。
//   実際のアップロード/ストリーミング挙動は次フェーズで接続。ここは設定の永続化のみ。
import { kvGet, kvSet } from './db.js'

const KEY = 'syncPrefs'
const DEFAULTS = {
  autoUpload: 'wifi',
  download: 'wifi',
}

let cache = null
export async function getSyncPrefs() {
  if (!cache) cache = { ...DEFAULTS, ...((await kvGet(KEY)) || {}) }
  return cache
}
export async function setSyncPref(k, v) {
  const p = await getSyncPrefs()
  p[k] = v
  await kvSet(KEY, p)
}

// Wi-Fi 判定（取れない環境は true 扱い＝従来どおり動く）。アップロード接続時に使う。
export function isLikelyWifi() {
  const c = navigator.connection || navigator.mozConnection || navigator.webkitConnection
  if (!c || !c.type) return true // 取得できない端末は制限しない
  return c.type === 'wifi' || c.type === 'ethernet'
}
